"use strict";

(function () {
  'use strict';

  angular.module('lr.Properties').constant('propertyFormConstants', {
    checkInsOut: [{
      name: 'All Properties',
      value: true,
      _id: 0
    }, {
      name: 'Arrivals',
      value: false,
      _id: 1
    }, {
      name: 'Departures',
      value: false,
      _id: 2
    }, {
      name: 'SameDay',
      value: false,
      _id: 3
    }],
    occupancy: [{
      name: 'Occupied and Unoccupied',
      value: true,
      _id: 0
    }, {
      name: 'Occupied',
      value: false,
      _id: 1
    }, {
      name: 'Unoccupied',
      value: false,
      _id: 2
    }],
    status: [{
      name: 'All Statuses',
      label: 'All Statuses',
      value: true,
      _id: 0
    }, {
      name: 'ReadyState',
      label: 'Ready',
      value: false,
      _id: 1
    }, {
      name: 'NotReady',
      label: 'Not Ready',
      value: false,
      _id: 2
    }, {
      name: 'InProgressState',
      label: 'In Progress',
      value: false,
      _id: 3
    }, {
      name: 'PendingState',
      label: 'Pending',
      value: false,
      _id: 4
    }, {
      name: 'FlaggedState',
      label: 'Flagged',
      value: false,
      _id: 5
    }],
    guestState: [{
      name: 'All Guest States',
      label: 'All Guest States',
      value: true,
      _id: 0
    }, {
      name: 'Guest Checked In Today',
      label: 'Guest Checked In Today',
      value: false,
      _id: 1
    }, {
      name: 'Guest Checked Out Today',
      label: 'Guest Checked Out Today',
      value: false,
      _id: 2
    }, {
      name: 'Guest Awaiting Check In',
      label: 'Guest Awaiting Check In',
      value: false,
      _id: 3
    }, {
      name: 'Guest Awaiting Check Out',
      label: 'Guest Awaiting Check Out',
      value: false,
      _id: 4
    }]
  }).constant('transactionConstants', {
    transactionNoteType: {
      transactionCustomer: 1,
      transaction: 2,
      customer: 3,
      payment: 4
    }
  });
})();